
<b-modal id="popup-alert-modal" hide-header hide-footer centered size="lg">
    <template #default="{close}">
        <div class="row mt-3 mb-3">
            <div class="col col-auto align-self-center">
                <b-icon icon="exclamation-octagon" />
            </div>
            <div class="col">
                <p>
                Toto je výstup Kontroly rizik veřejných zakázek provedený společností Datlab. Její závěry nedokazují pochybení či porušení zákona.
                Zjištěná rizika znamenají pouze vyšší možnost výskytu takových situací. Neměla by proto sama o sobě být kladena k tíži zadavatele ani dodavatele.
                Kontrola jako celek má sloužit jako vstup pro lepší nastavení vnitřních kontrolních postupů či hloubkový audit.
                </p>
            </div>
        </div>

        <b-button @click="close" size="sm" variant="outline-dark" block>{{ $t('button.close') }}</b-button>
    </template>
</b-modal>
